import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/deployments/list';
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Create new action types for silent requests
export const SILENT_REQUEST = 'SILENT_DEPLOYMENTS_LIST_REQUEST';

// Common function for processing both silent and regular requests
function* fetchDeploymentsData(action) {
  try {
    const { 
      page = 1, 
      limit = 20, 
      status = '', 
      model_id = '',
      workspace_id = ''
    } = action.payload || {};
    const isSilent = action.type === SILENT_REQUEST;
    
    // If this is not a silent refresh, trigger loading state
    if (!isSilent) {
      yield put({ type: 'DEPLOYMENTS_LIST_LOADING', payload: true });
    }
    
    // Build query parameters
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (status) params.append('status', status);
    if (model_id) params.append('model_id', model_id);
    if (workspace_id) params.append('workspace_id', workspace_id);
    
    const response = yield call(
      axios.get,
      `${config.API_URL}/deployments/?${params}`,
      { headers: getLocalUser() }
    );
    
    yield put(fetchSuccess(response.data));
    
    // If this was a silent refresh, dispatch an additional action for tracking
    if (isSilent) {
      yield put({ type: 'DEPLOYMENTS_LIST_SILENTLY_UPDATED', timestamp: new Date().getTime() });
    }
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  } finally {
    if (action.type !== SILENT_REQUEST) {
      // Reset loading state for non-silent requests
      yield put({ type: 'DEPLOYMENTS_LIST_LOADING', payload: false });
    }
  }
}

export function* watch() {
  yield takeLatest(REQUEST, fetchDeploymentsData);
  yield takeLatest(SILENT_REQUEST, fetchDeploymentsData);
}
